var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EasyDataTable } from '@easydata/core';
import { ExprTag, EqAggregatesContainer, Expression } from '@easyquery/core';
var EqServerAggregatesCalculator = /** @class */ (function () {
    function EqServerAggregatesCalculator(context) {
        this.context = context;
        this._needRecalculation = true;
        this.aggrContainer = new EqAggregatesContainer(context);
    }
    EqServerAggregatesCalculator.prototype.getAggrContainer = function () {
        return this.aggrContainer;
    };
    EqServerAggregatesCalculator.prototype.calculate = function (options) {
        this._needRecalculation = false;
        this.aggrContainer.clear();
        options = options || {};
        options.maxLevel = options.maxLevel >= 0
            ? options.maxLevel : 0;
        var levelPromises = [];
        var query = this.context.createQuery();
        query.loadFromData(this.context.getQuery().toJSONData());
        var settings = this.context.getQuery().getAggregationSettings();
        var aggregates = settings.getAggregates();
        var aggrColIds = settings.getAggregates().map(function (a) { return a.colId; });
        var aggrCols = query.getColumns()
            .filter(function (col) { return aggrColIds.indexOf(col.id) >= 0; });
        var _loop_1 = function (col) {
            query.changeColumnType(col, ExprTag.AggregateFunction, { funcId: aggregates.filter(function (a) { return a.colId == col.id; })[0].funcId });
        };
        for (var _i = 0, aggrCols_1 = aggrCols; _i < aggrCols_1.length; _i++) {
            var col = aggrCols_1[_i];
            _loop_1(col);
        }
        //get all non-aggregate columns
        var queryCols = query.getColumns()
            .filter(function (c) { return c.expr.tag !== ExprTag.AggregateFunction; });
        for (var _a = 0, queryCols_1 = queryCols; _a < queryCols_1.length; _a++) {
            var col = queryCols_1[_a];
            col.setHidden(true);
        }
        if (settings.hasRecordCount()) {
            var col = query.createColumn();
            col.caption = settings.COUNT_FIELD_NAME;
            col['_id'] = settings.COUNT_FIELD_NAME;
            var sqlText = 'COUNT(*)';
            var customSqlExpr = new Expression(col);
            customSqlExpr.tag = ExprTag.CustomSql;
            customSqlExpr.sql = sqlText;
            customSqlExpr.baseAttrId = null;
            col.expr = customSqlExpr;
            query.getColumns().push(col);
        }
        if (settings.hasGrandTotals()) {
            levelPromises.push(this.processLevel({
                query: query,
                level: 0,
                groupName: 'Grand Totals',
                resultObtainedCallback: options.resultObtained,
                errorOccurredCallback: options.errorOccurred
            }));
        }
        var groups = settings.getGroups();
        for (var level = 1; level <= groups.length; level++) {
            var group = groups[level - 1];
            for (var _b = 0, queryCols_2 = queryCols; _b < queryCols_2.length; _b++) {
                var col = queryCols_2[_b];
                col.setHidden(group.columns.indexOf(col.id) < 0);
            }
            levelPromises.push(this.processLevel({
                query: query,
                level: level,
                groupName: group.name,
                resultObtainedCallback: options.resultObtained,
                errorOccurredCallback: options.errorOccurred
            }));
        }
        return Promise.all(levelPromises)
            .then(function () {
            return;
        })
            .catch(function (error) { return console.error(error); });
    };
    EqServerAggregatesCalculator.prototype.processLevel = function (options) {
        var _this = this;
        var fetcher = this.context.getServices()
            .getDataFetcher();
        var fetchOptions = {
            aux: true,
            query: options.query
        };
        if (this.context.debugMode) {
            fetchOptions.debug = "Fetching group data. Group: '" + options.groupName + "', level: " + options.level;
        }
        var resultPromise = fetcher.fetchData(fetchOptions)
            .then(function (result) {
            var dataTable = new EasyDataTable({
                elasticChunks: true
            });
            var resultSet = result.resultSet;
            for (var _i = 0, _a = resultSet.cols; _i < _a.length; _i++) {
                var col = _a[_i];
                dataTable.columns.add(col);
            }
            for (var _b = 0, _c = resultSet.rows; _b < _c.length; _b++) {
                var row = _c[_b];
                dataTable.addRow(row);
            }
            var levelData = _this.buildLevelData(options.level, dataTable);
            _this.aggrContainer.setAggregateData(options.level, levelData);
            if (options.resultObtainedCallback) {
                options.resultObtainedCallback(result, options.level);
            }
        })
            .catch(function (error) {
            if (options.errorOccurredCallback) {
                options.errorOccurredCallback(__assign(__assign({}, error), { level: options.level }));
            }
        });
        return resultPromise;
    };
    EqServerAggregatesCalculator.prototype.buildLevelData = function (level, dataTable) {
        var aggrSettings = this.context.getQuery().getAggregationSettings();
        var keyColumns = level > 0
            ? aggrSettings.getGroups()[level - 1].columns
            : [];
        var valueColumns = aggrSettings.getAggregates().map(function (a) { return a.colId; });
        if (aggrSettings.hasRecordCount()) {
            valueColumns.push(aggrSettings.COUNT_FIELD_NAME);
        }
        var data = new Map();
        for (var _i = 0, _a = dataTable.getCachedRows(); _i < _a.length; _i++) {
            var row = _a[_i];
            var key = {};
            var value = {};
            for (var _b = 0, keyColumns_1 = keyColumns; _b < keyColumns_1.length; _b++) {
                var keyCol = keyColumns_1[_b];
                var colIdx = dataTable.columns.getIndex(keyCol);
                if (colIdx >= 0) {
                    var keyVal = row.getValue(keyCol);
                    if (!aggrSettings.caseSensitiveGroups && typeof (keyVal) === 'string') {
                        keyVal = keyVal.toLowerCase();
                    }
                    key[keyCol] = keyVal;
                }
            }
            for (var _c = 0, valueColumns_1 = valueColumns; _c < valueColumns_1.length; _c++) {
                var valueCol = valueColumns_1[_c];
                value[valueCol] = row.getValue(valueCol);
            }
            data.set(JSON.stringify(key), value);
        }
        return data;
    };
    EqServerAggregatesCalculator.prototype.needRecalculation = function () {
        return this._needRecalculation;
    };
    EqServerAggregatesCalculator.prototype.reset = function () {
        this._needRecalculation = true;
    };
    return EqServerAggregatesCalculator;
}());
export { EqServerAggregatesCalculator };
//# sourceMappingURL=eqs_aggr_calculator.js.map